import React from 'react';
import PublicWrapper from '../layouts/Public';
import HowItWorks from '../components/landing/HowItWorks';
import SecurePayment from '../components/landing/SecurePayment';
import {AboutUs, AboutUsForm} from '../components/landing/AboutUs';
import { AffiliatesBanner } from '../components/landing/Banners';
import Activities from '../components/landing/Activities';
import PromotionalVideoSection from '../components/landing/PromotionVideoSection';
import WhatsInItForYou from '../components/landing/WhatsInItForYou';
import JoinInMinutes from '../components/landing/JoinInMinutes';
import WhoShdJoin from '../components/landing/WhoShdJoin';
import WhyJoinCanam from '../components/landing/WhyJoinCanam';
import WhyTrustCanam from '../components/landing/WhyTrustCanam';
import ReadyToStartEarning from '../components/landing/ReadyToStartEarning';
import Testimonials from '../components/landing/Testimonials';
import LookingForNewFaces from '../components/landing/LookingForNewFaces';

const HomePublic = () => (
  <PublicWrapper>
    <AffiliatesBanner />
    <PromotionalVideoSection/>
    <AboutUs />
    <WhatsInItForYou />
    <HowItWorks />
    <JoinInMinutes />
    <SecurePayment />
    <WhoShdJoin />
    <WhyJoinCanam />
    <WhyTrustCanam />
    <ReadyToStartEarning />
    <Testimonials />
    <Activities />
    <AboutUsForm/>
    <LookingForNewFaces />
  </PublicWrapper>
);

export default HomePublic;
